<!--
  - Copyright 2019 Padduck, LLC
  -  Licensed under the Apache License, Version 2.0 (the "License");
  -  you may not use this file except in compliance with the License.
  -  You may obtain a copy of the License at
  -          http://www.apache.org/licenses/LICENSE-2.0
  -  Unless required by applicable law or agreed to in writing, software
  -  distributed under the License is distributed on an "AS IS" BASIS,
  -  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  -  See the License for the specific language governing permissions and
  -  limitations under the License.
  -->

<template>
  <div>
    <v-row
      v-for="(env, i) in value"
      :key="i"
    >
      <v-col
        cols="4"
        class="my-0 py-0"
      >
        <v-subheader v-text="i" />
      </v-col>
      <v-col
        cols="8"
        class="my-0 py-0"
      >
        <v-text-field
          v-model="value[i]"
          dense
          outlined
          hide-details
          append-outer-icon="mdi-close-circle"
          @click:append-outer="delete value[i]; $forceUpdate()"
        />
      </v-col>
    </v-row>
    <v-btn
      v-if="!addingEnvVar"
      text
      block
      @click="addingEnvVar = true"
      v-text="$t('templates.AddEnvVar')"
    />
    <v-row v-else>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="newEnvVar"
          :label="$t('common.Name')"
          dense
          outlined
          hide-details
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <v-btn
          color="primary"
          block
          @click="addEnvVar()"
          v-text="$t('templates.AddEnvVar')"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <v-btn
          color="error"
          block
          @click="newEnvVar = ''; addingEnvVar = false"
          v-text="$t('common.Cancel')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      addingEnvVar: false,
      newEnvVar: ''
    }
  },
  methods: {
    addEnvVar () {
      if (this.newEnvVar.trim().length > 0 && this.newEnvVar.trim().indexOf(' ') === -1) {
        this.value[this.newEnvVar.trim()] = ''
        this.newEnvVar = ''
        this.addingEnvVar = false
      } else {
        this.$toast.error(this.$t('templates.VarNameNoSpaces'))
      }
    }
  }
}
</script>
